export default class BaseSuggestor {
  constructor() {
    this.addressInputGroup = $('#address-input-group');
    this.addressInput = $('#address');
    this.latitudeInput = $('#latitude');
    this.longitudeInput = $('#longitude');
    this.ch1903xInput = $('#ch1903x');
    this.ch1903yInput = $('#ch1903y');
    this.streetInput = $('#street');
    this.houseNumberInput = $('#house-number');
    this.zipInput = $('#zip');
    this.cityInput = $('#city');

    this.setupValidations = this.setupValidations.bind(this);
    this.setupValidations();
  }

  setupValidations() {
    // Clear latitude and longitude on input
    this.addressInput.on('input', () => {
      this.latitudeInput.val('');
      this.longitudeInput.val('');
      this.ch1903xInput.val('');
      this.ch1903yInput.val('');
      this.streetInput.val('');
      this.houseNumberInput.val('');
      this.zipInput.val('');
      this.cityInput.val('');
    });

    // Validate on change
    this.addressInput.on('change', () => {
      // 200 microsecond timeout because this event fires before the onSelect-event
      setTimeout(() => {
        this.addressInputGroup.trigger('validate');
      }, 200);
    });

    // Custom validation event
    this.addressInputGroup.on('validate', (event) => {
      const element = $(event.currentTarget);
      if (this.addressInput.getValidity() === true && this.latitudeInput.getValidity() === true &&
          this.longitudeInput.getValidity() === true && this.zipInput.getValidity() === true  &&
          this.houseNumberInput.getValidity() === true) {
        element.setValidityClass(true);
      } else {
        element.setValidityClass(false);
      }
    });
  }
}
